var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="region-header" class="workspace-header">\n	<div class="main">\n		<h1 class="monitor-title">Publication Monitor</h1>\n		\n		<button class="btn js-bulkaction js-finalize" data-final="true" disabled>Mark as final</button>\n		<button class="btn js-bulkaction js-finalize" data-final="false" disabled>Unmark as final</button>\n	</div>\n</div>\n<div id="region-body" class="workspace-content single-column no-scroll"></div>\n';
}
return __p;
};
